import React, { useState } from 'react';

const BrandMessages: React.FC = () => {
  const [selectedConversation, setSelectedConversation] = useState<number | null>(1);
  const [newMessage, setNewMessage] = useState('');

  const conversations = [
    { id: 1, name: 'Sarah Lee', lastMessage: 'Thanks for the update!', time: '2m ago', unread: 2 },
    { id: 2, name: 'Tech Reviewer', lastMessage: 'Great work on the content!', time: '1h ago', unread: 0 },
    { id: 3, name: 'Beauty Queen', lastMessage: 'When can we discuss the brief?', time: '3h ago', unread: 1 },
  ];

  const messages = [
    { id: 1, sender: 'brand', text: 'Hi! Thank you for accepting our campaign invitation.', time: '10:30 AM' },
    { id: 2, sender: 'kol', text: "Hi! Excited to work with you on this campaign. I've reviewed the brief and have some ideas.", time: '10:35 AM' },
    { id: 3, sender: 'brand', text: "That's great! We'd love to hear your ideas.", time: '10:40 AM' },
    { id: 4, sender: 'kol', text: 'I was thinking we could do a series of Reels showing different ways to style the summer collection.', time: '10:42 AM' },
    { id: 5, sender: 'brand', text: "Love that idea! Let's discuss the details.", time: '10:45 AM' },
  ];

  return (
    <div className="ph-no-capture space-y-6 text-glass-text">
      <div>
        <h1 className="page-title">Messages</h1>
        <p className="text-glass-text-2 text-sm mt-1">Chat with KOLs on active campaigns</p>
      </div>

      <div className="glass-card flex min-h-[560px] overflow-hidden">
        <div className="w-full max-w-sm border-r border-glass flex flex-col">
          <div className="p-4 border-b border-glass">
            <h2 className="font-semibold text-glass-text">Conversations</h2>
          </div>
          <div className="flex-1 overflow-y-auto">
            {conversations.map((conv) => (
              <button
                key={conv.id}
                type="button"
                onClick={() => setSelectedConversation(conv.id)}
                className={`w-full text-left p-4 border-b border-glass transition ${
                  selectedConversation === conv.id ? 'bg-accent2/10' : 'hover:bg-glass-3/40'
                }`}
              >
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-semibold text-glass-text">{conv.name}</h3>
                  <span className="text-xs text-glass-text-3">{conv.time}</span>
                </div>
                <p className="text-sm text-glass-text-2 truncate">{conv.lastMessage}</p>
                {conv.unread > 0 && (
                  <span className="inline-block mt-1 status-pill status-pill-info">{conv.unread} new</span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div className="flex-1 flex flex-col min-w-0">
          {selectedConversation ? (
            <>
              <div className="p-4 border-b border-glass">
                <h3 className="page-title text-lg">
                  {conversations.find((c) => c.id === selectedConversation)?.name}
                </h3>
              </div>

              <div className="flex-1 overflow-y-auto p-4 space-y-4">
                {messages.map((msg) => (
                  <div key={msg.id} className={`flex ${msg.sender === 'brand' ? 'justify-end' : 'justify-start'}`}>
                    <div
                      className={`max-w-md px-4 py-3 rounded-xl ${
                        msg.sender === 'brand' ? 'bg-accent2 text-white' : 'glass-card-tight text-glass-text'
                      }`}
                    >
                      <p>{msg.text}</p>
                      <p className={`text-xs mt-1 ${msg.sender === 'brand' ? 'text-white/70' : 'text-glass-text-3'}`}>
                        {msg.time}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="p-4 border-t border-glass">
                <div className="flex gap-3">
                  <input
                    type="text"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Type your message..."
                    className="glass-input flex-1 px-4 py-2"
                  />
                  <button type="button" className="btn-accent px-6 py-2 text-sm font-semibold">
                    Send
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="flex-1 flex items-center justify-center text-glass-text-2">
              <p>Select a conversation to start messaging</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BrandMessages;
